import { render, staticRenderFns } from "./CompanyMean.vue?vue&type=template&id=40fa20f7&scoped=true&"
import script from "./CompanyMean.vue?vue&type=script&lang=js&"
export * from "./CompanyMean.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMean.vue?vue&type=style&index=0&id=40fa20f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa20f7",
  null
  
)

export default component.exports